import { find, get, indexOf, isEqual, map, merge, reduce, slice, } from "lodash";

import createPath from '../../utils/path';

// Check if the new cursor is stuck in the same index in the same path
export const isCursorStuck = (oldCursor, newCursor) => {
  const oldIndex = get(oldCursor, 'index');
  const oldPath = get(oldCursor, 'path');

  const newIndex = get(newCursor, 'index');
  const newPath = get(newCursor, 'path');

  return oldIndex === newIndex && isEqual(oldPath, newPath);
}

export const getProgress = (state) => {
  // TODO: move this configuration data to the survey document once this implementation is stable
  const STARTING_QUESTION = 'CR2a';
  const QUESTION_WEIGTH = 1;

  const INITIAL_ANSWER = {
    "CR_DPB1": {
      answer: {
        "CR_DPB1_7": {
          value: "7"
        }
      }
    }
  };

  const INITIAL_CONTEXT = {
    "CR2a": {
      custom : {
        "CR2c_SECTOR": {
          name: "CR2a_1"
        }
      }
    }
  };

  const payload = get(state, ['payload']);

  const graph = get(payload, ['graph']);
  const blocks = get(state, ['blocks']);
  const questions = get(state, ['questions']);

  // Calculate path without taking logic into account
  const path_vector = graph
    .map(block => find(blocks, { name: block.name })) // Find block object for each block name
    .map(block => get(find(graph, { name: block.name }), 'values', [])) // For each block pass its array of questions
    .reduce((a, b) => a.concat(b), []); // Flatten array of arrays of questions

  const currentQuestion = get(state, ['payload', 'current']);

  // console.log(`Starting question ${STARTING_QUESTION} at index ${indexOf(path_vector, STARTING_QUESTION)}`);
  // console.log(`Current question ${currentQuestion} at index ${indexOf(path_vector, currentQuestion)}`);

  // Display progress bar once the starting question has been reached
  if (indexOf(path_vector, currentQuestion) < indexOf(path_vector, STARTING_QUESTION)) {
    const progress = { status: 'disabled' };
    // console.log(`Progress status: ${progress.status}`);
    return progress;
  } else {
    // Create initial state in memory containing the predefined data
    const context = {
      answer: merge({}, INITIAL_ANSWER, payload.answer),
      context: merge({}, INITIAL_CONTEXT, payload.context),
      // metadata: { ...state.meta, locale: state.i18n.locale },
    };

    // Note that path might be different from the real one as we inject some predefined values
    const params = get(state, 'params');
    const subset_path = createPath(blocks, questions, graph, context, params);
    // console.log(`Subset path: ${subset_path}`);

    const subset_index = indexOf(subset_path, currentQuestion);
    // console.log(`Current question index in subset path: ${subset_index}`);

    // Both past and future path exclude the current question
    const past_path = slice(subset_path, 0, subset_index);
    const future_path = slice(subset_path, subset_index + 1);

    const subset_time_past = reduce(map(past_path, q => QUESTION_WEIGTH ), (sum, n) => sum + n, 0);
    const subset_time_future = reduce(map(future_path, q => QUESTION_WEIGTH), (sum, n) => sum + n, 0);
    // console.log(`Past subset path: ${subset_time_past}`);
    // console.log(`Future subset path: ${subset_time_future}`);

    const progress = { status: 'enabled', value: subset_time_past / (subset_time_past + subset_time_future) };
    // console.log(`Progress status: ${progress.status} : ${progress.value}`);

    return progress;
  }
};

export default {
  isCursorStuck,
  getProgress
};
